import React, { ReactElement } from 'react'
import ReactMarkdown from 'react-markdown'
import { ThemeUIStyleObject } from 'theme-ui'

export default function UnstyledMarkdown({
  children,
  sxx,
}: {
  children?: Queries.Maybe<string>
  sxx?: ThemeUIStyleObject
}): ReactElement {
  return (
    <ReactMarkdown
      sx={{
        '&>:first-child': {
          marginTop: 0,
        },
        '&>:last-child': {
          marginBottom: 0,
        },
        ...sxx,
      }}
    >
      {children}
    </ReactMarkdown>
  )
}
